/* global Flickity */

export default class Slider {
  constructor(sliderEl = null) {
    this.sliderEl = sliderEl || false;

    if (this.sliderEl && this.sliderEl.dataset.slider) {
      const options = JSON.parse(this.sliderEl.dataset.slider);
      this.slider = new Flickity(this.sliderEl, options);
      this.arrows = this.sliderEl.querySelectorAll('.arrows-wrapper');

      this.init();
      this.events();
    }
  }

  init() {}

  changeCurrentNumber(index) {
    this.arrows.forEach(arrowWrapper => {
      arrowWrapper.querySelector('.current').innerText = index;
    });
  }

  gotoPreviousSlide(ev) {
    this.slider.previous(true);
  }

  gotoNextSlide(ev) {
    this.slider.next(true);
  }

  changeSlide(index) {
    this.changeCurrentNumber( index + 1 );
  }

  events() {
    this.slider.on( 'select',this.changeSlide.bind(this));

    this.arrows.forEach(arrowWrapper => {
      let leftArrow = arrowWrapper.querySelector('.arrow-left');
      let rightArrow = arrowWrapper.querySelector('.arrow-right');
      leftArrow.addEventListener('click', this.gotoPreviousSlide.bind(this));
      rightArrow.addEventListener('click', this.gotoNextSlide.bind(this));
    });
  }
}
